import emailRegex from 'front-end/src/app/services/emailRegex'
import React from 'react'
import { t, Trans } from '@lingui/macro'
import { useParams } from 'react-router'
import { linkBuilder, staticLinks } from 'shared/linkBuilder'
import { navigateTo } from '../../../app/util/appHistory'
import '../Auth.less'
import Link from 'front-end/src/components/common/link/Link'
import {
  useGenerateResetPasswordLinkMutation,
  useOrganisationJustIdQuery
} from 'front-end/src/pages/auth/reset-password/ResetPassword.codegen'
import { notification } from 'front-end/src/components/common/notifications/Notifications'

const ResetEmailSent = () => {
  const { email } = useParams<{ email: string }>()
  const { data, loading } = useOrganisationJustIdQuery({
    fetchPolicy: 'cache-first'
  })

  const [generateResetPasswordLink] = useGenerateResetPasswordLinkMutation({
    onCompleted: () => {
      // even if email is not valid, we show success message for security reasons
      notification.info(t`Email sent successfully `)
      navigateTo(linkBuilder.resetPasswordSent(email))
    }
  })

  if (loading) {
    return null
  }

  const isEmailValid = !!emailRegex.exec(email)

  return (
    <div className="Auth">
      <div className="Auth__container">
        {isEmailValid ? (
          <>
            <h3>
              <Trans>
                An email with activation link was sent to{' '}
                <strong>{email}</strong>.
              </Trans>
            </h3>
            <div className="Auth__text">
              <p>
                <Trans>
                  Simply click on the link in the email to set new password.
                </Trans>
              </p>
              <div className="verificationIcon">
                <span className="icon icon-envelope-letter icon-large" />
              </div>
            </div>
          </>
        ) : (
          <h3>
            <Trans>
              <strong>{email}</strong> is not valid email. Please contact your
              manager.
            </Trans>
          </h3>
        )}
      </div>

      {isEmailValid && (
        <p className="bottomLink">
          <Trans>Haven't received the email?</Trans>
          <br />
          <Link
            className="clickable"
            onClick={async () =>
              generateResetPasswordLink({
                variables: {
                  email,
                  organisationId: data.organisation.id
                }
              })
            }
          >
            <Trans>Resend email</Trans>
          </Link>
        </p>
      )}

      <p className="bottomLink">
        <Link onClick={() => navigateTo(staticLinks.login)}>
          <Trans>Back to the main login view</Trans>
        </Link>
      </p>
    </div>
  )
}

export default ResetEmailSent
